export enum TipoCartorio {
    Notas = 0,
    Imoveis = 1,
    Protesto = 2,
}
